import { columns } from "@/mocks/blog";

export default function ColumnsSection() {
  return (
    <section id="columns" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">COLUMNS</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              栏目专题 · <span className="text-primary-600">换个频道继续聊</span>
            </h2>
          </div>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {columns.map((col, idx) => (
            <article
              key={col.name}
              className="group relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:shadow-[0_10px_30px_oklch(var(--background-300)/0.4)]"
            >
              <span
                className={`absolute right-4 top-3 font-display text-4xl font-black ${
                  idx % 2 === 0 ? "text-primary-100" : "text-secondary-100"
                } group-hover:text-transparent`}
                aria-hidden="true"
              >
                0{idx + 1}
              </span>
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                  idx % 2 === 0 ? "bg-primary-100 text-primary-600" : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={`${col.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-foreground-950">{col.name}</h3>
              <p className="mt-0.5 text-sm font-semibold text-primary-600">{col.title}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-xs font-medium text-foreground-500">
                <i className="ri-file-text-line" aria-hidden="true"></i>
                {col.count} · 持续更新中
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}